import React from 'react';
import { Translate } from 'core/translate';

const ConvertibleControls = ({
  enabled,
  isTopDown,
  analyticsKey,
  onToggle
}) => {
  if (!enabled) {
    return null;
  }

  return (
    <div className="carousel-convertible">
      <span className="carousel-convertible__top-label">
        <Translate value="convertible.top" />
      </span>
      <a
        className={`carousel-convertible__link stat-button-link ${
          isTopDown ? '' : 'active'
        }`}
        data-dtm={analyticsKey}
        data-dtm2="up"
        onClick={() => {
          if (isTopDown) {
            onToggle();
          }
        }}>
        <Translate value="convertible.up" />
      </a>
      <a
        className={`carousel-convertible__link stat-button-link ${
          isTopDown ? 'active' : ''
        }`}
        data-dtm={analyticsKey}
        data-dtm2="down"
        onClick={() => {
          if (!isTopDown) {
            onToggle();
          }
        }}>
        <Translate value="convertible.down" />
      </a>
    </div>
  );
};

export default ConvertibleControls;
